// @ts-ignore
import BExt from '@cap/bext';
import KNB from '@dp/knb';
import { omit } from 'lodash-es';

/* eslint-disable camelcase */
/* eslint-disable import/extensions */
import qs from 'query-string';
import { isIOS, isMMP } from '@cap/utils';
import { isBrowser } from '@cap/ssr-common-utils';
import { defaultShareDesc, defaultSharePic, defaultShareTitle } from '../../constants';
import { logger } from '../logger';
import { domainWhiteListCheck, getCommonParams, isAbsoluteURL } from '../urlHelper';
import { isInFrame, isMaoYan } from '../runtimeEnv';
import {
  MMP_APP_SCHEMA,
  OPEN_PAGE_ACTION,
  OpenPageOptions,
  getHostApp,
  transferUrl,
  ShareParams,
} from './common';
import { loginNewWrapper } from '../loginWrapper/loginNew';
import wxAdapter from './adapter-wx';

BExt.register(wxAdapter);
// BExt.register(knbAdapter);
BExt.config(); // 尽量放在入口位置，因为这是一个异步的过程，而且加载 sdk 可能会需要一些时间

type VoidFunctionType = (params: any) => void;

// 初始化 Bext 组件
if (window.location.search.indexOf('debug=1') > -1) {
  BExt.setMode(true);
}

// 各个业务自己去初始化
// BExt.config(); // 尽量放在入口位置，因为这是一个异步的过程，而且加载 sdk 可能会需要一些时间

BExt.error((err: Error) => {
  logger.log('BExt.error: ', err);
});

export interface NavigateToParams extends OpenPageOptions {
  onBefore?: Function;
  tenant?: string;
}

export function subscribeAppear(cb: () => void) {
  BExt.ready(() =>
    BExt.subscribe({
      action: 'appear',
      handle: () => cb && cb(),
    }),
  );
}

export function subscribeDisappear(cb: () => void) {
  BExt.ready(() =>
    BExt.subscribe({
      action: 'disappear',
      handle: () => cb && cb(),
    }),
  );
}

const addSource = function (url: string) {
  const urlObj = qs.parseUrl(url);
  const { enterResource = null } = getCommonParams();
  urlObj.query.source = urlObj.query.source || 'meituan_app';
  urlObj.query.enterResource = urlObj.query.enterResource
    ? urlObj.query.enterResource
    : enterResource || 'new';
  return qs.stringifyUrl(urlObj);
};
/**
 * 触发knb的configShare方法
 * @see https://km.sankuai.com/collabpage/427900953
 * @param config
 */
export function configShare(config: Record<string, any>) {
  if (isIOS(navigator.userAgent) && isMaoYan()) {
    config.image += '?may_covertWebp'; // 猫眼: https://km.sankuai.com/page/116753004
  }
  config.url = addSource(config.url);
  config.desc = config.desc || defaultShareDesc;
  config.content = config.content || defaultShareDesc;
  config.title = config.title || defaultShareTitle;

  BExt.ready(() =>
    BExt.configShare({
      channel: [
        BExt.share.WECHAT_TIMELINE,
        BExt.share.WECHAT_FRIENDS,
        BExt.share.WEIBO,
        BExt.share.QQ,
        BExt.share.QZONE,
      ],
      ...config,
    }),
  );
}

export function getUA(cb: VoidFunctionType) {
  BExt.ready(() =>
    BExt.getUA({
      success: cb,
      fail: cb,
    }),
  );
}

export function getAppInfo(cb: VoidFunctionType) {
  BExt.ready(() => BExt.getAppInfo(cb));
}

export function openMiniProgram(id: string, path: string) {
  BExt.ready(() =>
    BExt.openMiniProgram({
      miniProgramId: id,
      path,
    }),
  );
}

/**
 * 根据 schema 打开MMP小程序页面
 * @param id
 * @param targetUrl
 * @param schema
 */
export const openMmpPage = (id: string, targetUrl: string) => {
  const hostApp = getHostApp();
  const schema = MMP_APP_SCHEMA[hostApp];
  BExt.ready(() =>
    BExt.openPage({
      url: `${schema}mmp?appId=${id}&targetPath=${targetUrl}`,
    }),
  );
};

/**
 * 打开美团App下小程序页面
 * @param id
 * @param targetUrl
 */
export function openMTMmpPage(id: string, targetUrl: string) {
  BExt.ready(() =>
    BExt.openPage({
      url: `imeituan://www.meituan.com/mmp?appId=${id}&targetPath=${targetUrl}`,
    }),
  );
}

/**
 * 触发knb的setNavigationBarHidden方法
 * @param options
 */
export function setNavigationBarHidden(options: Record<string, any>) {
  BExt.ready(() => BExt.setNavigationBarHidden(options));
}
/**
 * 触发knb的setNavButtons方法
 * @see https://km.sankuai.com/collabpage/422294311
 * @param options
 */
export function setNavButtons(options: Record<string, any>) {
  BExt.ready(() => BExt.setNavButtons(options));
}

export { BExt };

export function closePage() {
  BExt.closePage({
    fail() {
      window.history.back();
    },
  });
}

/**
 * 通用分享
 * @param query
 * @see https://km.sankuai.com/page/418150035
 * @returns
 */
export function shareDefault(config: ShareParams) {
  config.url = addSource(config.url);
  config.title = config.title || defaultShareTitle;
  config.desc = config.desc || defaultShareDesc;
  config.content = config.content || defaultShareDesc;
  config.image = config.image || defaultSharePic;
  config.channel = (
    Array.isArray(config.channel) ? config.channel : [config.channel]
  ) as Array<number>;
  BExt.ready(() => {
    BExt.share({
      ...omit(config, ['cid']),
      panel: {
        cid: config.cid,
      },
    });
  });
}

/**
 * 分享微信或微信朋友圈
 * @see https://km.sankuai.com/page/418150035
 * @param config
 */
export function shareToWx(config: ShareParams) {
  shareDefault({
    ...config,
    // channel 为1是分享微信 channel 为2是分享微信朋友圈
    channel: config.channel === 1 ? [BExt.share.WECHAT_FRIENDS] : [BExt.share.WECHAT_TIMELINE],
    cid: 'c_gx3sygn7',
  });
}

/**
 * 分享图片至微信好友/朋友圈
 * @param query
 * @returns
 */
export function shareImageToWx(
  channel: 'WECHAT_TIMELINE' | 'WECHAT_FRIENDS',
  picUrl: string,
  minUrl: string,
) {
  return new Promise((resolve, reject) => {
    BExt.ready(() => {
      BExt.shareImage({
        picQuality: 100,
        image: picUrl,
        thumbPic: minUrl,
        channel: channel === 'WECHAT_TIMELINE' ? 1 : 0,
        success(result: unknown) {
          resolve(result);
        },
        fail(res: Error) {
          reject(res);
        },
      });
    });
  });
}

/**
 * 统一的openPage方法,非白名单的url，不添加query参数
 * @param {string} url
 * @param {OpenPageOptions} options
 * @returns
 */
export const openPage = async (url: string, options: OpenPageOptions = {}) => {
  if (!isBrowser) return;

  const {
    direct = false,
    anime = 'fadeIn',
    windowOpen = false,
    replace = false,
    source = '',
    action = undefined,
    appId = undefined,
    isCloseCurrentWebview = false,
    query: search = {},
  } = options;
  // 非白名单的外部域名地址，不添加query参数
  if (!direct && domainWhiteListCheck(url)) {
    if (
      ![
        OPEN_PAGE_ACTION.TITANS_TO_MMP,
        OPEN_PAGE_ACTION.WXWPP_SWITCHTAB,
        OPEN_PAGE_ACTION.MINIAPP_NAVIGATETO,
      ].includes(action as string) &&
      !isAbsoluteURL(url)
    ) {
      const { origin } = window.location;
      url = origin + url;
    }
    // qs.stringifyUrl 默认支持扩展 query 对象。不需要先格式化
    let query = {
      ...getCommonParams(), // 设置通用业务参数，可以被url指定的同名参数覆盖
      ...search,
    };
    if (source) {
      query.source = source;
    } else if (url.includes('source')) {
      // url 中包含source, 则格式化source
      const {
        query: { source: urlSource },
      } = qs.parseUrl(url);
      urlSource && (query.source = urlSource);
    }
    // 美团小程序下增加usertoken信息
    if (isMMP(navigator.userAgent)) {
      const user = await loginNewWrapper.getUserInfo();
      if (user) {
        query = {
          ...query,
          mmp_type: 'MT',
          mmp_code: (user as any).token,
        } as any;
      }
    }
    url = qs.stringifyUrl(
      {
        url,
        query,
      },
      { sort: false },
    ); // 不需要对keys排序
  }
  const top = isInFrame() ? window.top : window;

  // 根据环境处理url
  // B端下的二级页面跳转到B端，C端域名下的二级页面跳转到C端
  url = transferUrl(url);

  /**
   * mmp 的 webView 跳转到titans容器
   */
  const mmpToTitans = () => {
    const hostApp = getHostApp();
    const schame = MMP_APP_SCHEMA[hostApp];
    if (schame) {
      top && (top.location.href = `${schame}web?url=${encodeURIComponent(url)}`); // 用 Titans 容器打开 Web 页面)
    } else {
      top && (top.location.href = url);
    }
  };

  /**
   * webView页面跳转小程序某个页面
   */
  const miniAppNavgateTo = () => {
    window.wx.miniProgram.navigateTo({
      url,
      fail: () => {
        top && (top.location.href = url);
      },
    });
  };

  switch (action) {
    case OPEN_PAGE_ACTION.TITANS_TO_MMP:
      openMmpPage(appId as string, encodeURIComponent(url));
      break;
    case OPEN_PAGE_ACTION.WXWPP_SWITCHTAB:
      window.wx.miniProgram.switchTab({
        url,
      });
      break;
    case OPEN_PAGE_ACTION.MMP_TO_TITANS:
      mmpToTitans();
      break;
    case OPEN_PAGE_ACTION.MINIAPP_NAVIGATETO:
      miniAppNavgateTo();
      break;
    default:
      if (isMMP(navigator.userAgent)) {
        mmpToTitans();
        return;
      }
      if (replace) {
        top?.location.replace(url);
      } else if (isCloseCurrentWebview) {
        BExt.ready(() => {
          BExt.jumpPage({ url });
        });
      } else {
        BExt.ready(() => {
          BExt.openPage({ url, anime, windowOpen, topLocation: isInFrame() });
        });
      }
      break;
  }
};

export const setNavigationBar = (backgroundColor: string, color?: string) => {
  if (!isBrowser) return;

  return new Promise((resolve) => {
    BExt.ready(() => {
      KNB.use('setNavigationBar', {
        backgroundColor, // rgba 色值
        color, // rgb 色值
        animated: false,
        success() {
          console.log('setNavigationBar成功');
          resolve('setNavigationBar成功');
        },
        fail(error: Error) {
          console.error(error);
          logger.log('setNavigationBar失败', error);
        },
      });
    });
  });
};

export const setStatusBarStyle = (style: number, backgroundColor: string) => {
  if (!isBrowser) return;

  return new Promise((resolve) => {
    BExt.ready(() => {
      BExt.use('setStatusBarStyle', {
        style,
        backgroundColor,
        success() {
          console.log('setStatusBarStyle成功');
          resolve('setStatusBarStyle成功');
        },
        fail(error: Error) {
          console.error(error);
          logger.log('setStatusBarStyle失败', error);
        },
      });
    });
  });
};
